import EventEmitter from 'eventemitter3'
import type { ItemType, TabsItemType } from '@ve-pro/ve/aside/config/aside-type'
import { AssetGroup } from '@ve-pro/api/asset-group/type'
import type { AiTaskModel } from '@/api/ai/index.type'
import type {
  FileListTypeProperty,
  FileExtraProp,
} from '@ve-pro/ve/aside/config/aside-type'

export interface AlreadyOption {
  id: string
  file_uuid: string
  fileExtraProp?: FileExtraProp
}

export interface AsideEvents {
  // 刷新列表
  activeTabList: (item: TabsItemType) => void

  // 左侧目录创意制作面板选中
  asideMenuActive: (active: ItemType['type']) => void

  // 上传成功
  fileSuccess: () => void

  // 进入指定的组详情
  enterGroup: (assetGroupId: AssetGroup['id']) => void

  // 展示分镜弹框
  fileVideoClip: (file: FileListTypeProperty) => void

  // 配音成功
  speechSuccessArray: (successArray: AiTaskModel[]) => void

  // 更新资产组列表
  updateFileList: () => void

  // 本地上传资源存在的情况
  already: (data: AlreadyOption) => void

  // 自动更新配音
  updateDub: (options?: { force?: boolean }) => void
}

export const AsideEventter = new EventEmitter<AsideEvents>()
